<template>
  <div>
    <v-toolbar :color="pageColor" dark app>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>
        State Road
        <span class="font-weight-light">Constructions</span> - DMS
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <!-- MENU FOR NOTIFS-->
        <!-- <notifs></notifs> -->
        <!-- END MENU FOR NOTIFS-->
        <!-- <v-btn large icon>
                    <v-icon>more_vert</v-icon>
        </v-btn>-->
      </v-toolbar-items>
    </v-toolbar>

    <v-navigation-drawer
      persistent
      :mini-variant="false"
      :clipped="false"
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>

    <v-content>
      <transition name="fadeBackEnd" mode="out-in">
        <router-view></router-view>
      </transition>
    </v-content>

    <v-snackbar v-model="snackbarState" :right="true" :timeout="60000" :top="true" :vertical="false">
      {{snackbarText}}
      <v-btn :color="snackbarColor" flat @click="snackbarState = false">Close</v-btn>
    </v-snackbar>

    <user-settings></user-settings>
    <!-- <socket-updates></socket-updates> -->
  </div>
</template>

<script>
//import Notifs from '@/components/misc/notifs.vue'
import SideDrawer from '@/components/misc/sideDrawer.vue'
import RouteProps from '@/services/mixins/routeProps'

import UserSettings from '@/components/central/userSettings.vue'
//import SocketUpdates from '@/components/central/socketUpdates.vue'
export default {
  mixins: [RouteProps],
  data() {
    return {
      drawer: true,
      options: false
    }
  },
  methods: {
    setTopLevelPages() {
      var usersTopLevelPages = this.$store.state.global.possibleTopLevelPages.filter(
        page => {
          return (
            this.$store.state.user.userAuthClass[`${page.link}Read`] ||
            this.$store.getters['user/isAdmin']
          )
        }
      )
      this.$store.commit('global/setState', {
        prop: 'topLevelPages',
        value: usersTopLevelPages
      })
    },
    setMinorPages() {
      var usersMinorPages = this.$store.state.global.possibleMinorPages.filter(
        page => {
          if (
            page.link == 'project' ||
            page.link == 'site' ||
            page.link == 'spoil' ||
            page.link == 'report'
          ) {
            return this.$store.state.user.userAuthClass[`clientRead`]
          } else if (page.link == 'driver' || page.link == 'vehicle') {
            return this.$store.state.user.userAuthClass[`contractorRead`]
          }
          return this.$store.state.user.userAuthClass[`${page.link}Read`]
        }
      )
      this.$store.commit('global/setState', {
        prop: 'minorPages',
        value: usersMinorPages
      })
    }
  },
  computed: {
    pageColor() {
      if (!!this.routeProps) {
        return this.routeProps.color
      } else {
        return 'primary'
        //return "blue darken-4"
      }
    },
    snackbarState: {
      get() {
        return this.$store.state.global.snackbarState
      },
      set(state) {
        this.$store.commit('global/modifySnackbarState', state)
      }
    },
    snackbarColor() {
      return this.$store.state.global.snackbarColor
    },
    snackbarText() {
      return this.$store.state.global.snackbarText
    }
  },
  mounted() {
    this.setTopLevelPages()
    this.setMinorPages()
  },
  components: {
    //Notifs,
    SideDrawer,
    UserSettings
    //SocketUpdates
  }
}
</script>

<style>
.fadeBackEnd-enter-active,
.fadeBackEnd-leave-active {
  transition: opacity 0.2s;
}
.fadeBackEnd-enter, .fadeBackEnd-leave-to /* .fadeBackEnd-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.profile-item .v-list__item {
  height: 90px;
}

.overlap-fab-user {
  right: 40px;
  bottom: -17px;
  position: absolute !important;
}
</style>
